import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spreadsheet from "react-spreadsheet";
import VesselHeader from "../../components/Vessel/VesselHeader";
import { getUKMRVData } from "../../services/complianceService";
import BenchmarkYearPicker from "../../components/Common/BenchmarkYearPicker";
import ExportToExcel from "../../components/Common/ExportToExcel";

const UKMRV = () => {
  const dispatch = useDispatch();
  const { currentVessel } = useSelector((state) => state.vesselOverview);

   const staticData = [
    [
      { value: "Segment Type", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Sea Days", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "HFO Consumption (MT)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "HFO CO₂ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "HFO N₂O Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "HFO CH₄ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "LFO Consumption (MT)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "LFO CO₂ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "LFO N₂O Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "LFO CH₄ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "MDO Consumption (MT)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "MDO CO₂ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "MDO N₂O Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "MDO CH₄ Factor", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "N₂O Emissions (t)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "CH₄ Emissions (t)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Distance Sailed (nm)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Transport Work (t·nm)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "CO₂ per nm (t/nm)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "CO₂eq per nm (t/nm)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "CO₂ per Transport Work", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "CO₂eq per Transport Work", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Fuel Consumption per nm (MT/nm)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Fuel Consumption per Transport Work", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Total CO₂ Emissions (t)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" },
      { value: "Total GHG Emissions (tCO₂e)", readOnly: true, className: "font-bold bg-blue-50 text-blue-800" }
    ],
    // [
    //   { value: "At UK Ports", readOnly: true, className: "font-bold bg-gray-50" },
    //   { value: "12.5", readOnly: true, className: "font-medium" },
    //   { value: "45.2", readOnly: true, className: "font-medium" },
    //   { value: "3.114", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00018", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00005", readOnly: true, className: "font-medium" },
    //   { value: "22.8", readOnly: true, className: "font-medium" },
    //   { value: "3.151", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00018", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00005", readOnly: true, className: "text-blue-600" },
    //   { value: "7.6", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "3.206", readOnly: true, className: "font-medium" },
    //   { value: "0.00018", readOnly: true, className: "font-mono" },
    //   { value: "0.00005", readOnly: true, className: "font-medium" },
    //   { value: "0.00234", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00078", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "1250.5", readOnly: true, className: "font-medium" },
    //   { value: "12505000", readOnly: true, className: "font-mono" },
    //   { value: "0.045200", readOnly: true, className: "font-medium" },
    //   { value: "0.046150", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00000362", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00000369", readOnly: true, className: "font-medium" },
    //   { value: "0.060400", readOnly: true, className: "font-medium" },
    //   { value: "0.00000483", readOnly: true, className: "font-mono" },
    //   { value: "56.50", readOnly: true, className: "text-blue-600 font-bold" },
    //   { value: "57.68", readOnly: true, className: "font-mono bg-blue-50/30 font-bold" }
    // ],
    // [
    //   { value: "Between UK Ports", readOnly: true, className: "font-bold bg-gray-50" },
    //   { value: "8.2", readOnly: true, className: "font-medium" },
    //   { value: "78.9", readOnly: true, className: "font-medium" },
    //   { value: "3.114", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00018", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00005", readOnly: true, className: "font-medium" },
    //   { value: "39.5", readOnly: true, className: "font-medium" },
    //   { value: "3.151", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00018", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00005", readOnly: true, className: "text-blue-600" },
    //   { value: "13.2", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "3.206", readOnly: true, className: "font-medium" },
    //   { value: "0.00018", readOnly: true, className: "font-mono" },
    //   { value: "0.00005", readOnly: true, className: "font-medium" },
    //   { value: "0.00412", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00137", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "890.3", readOnly: true, className: "font-medium" },
    //   { value: "8903000", readOnly: true, className: "font-mono" },
    //   { value: "0.088600", readOnly: true, className: "font-medium" },
    //   { value: "0.090450", readOnly: true, className: "text-blue-600" },
    //   { value: "0.00000995", readOnly: true, className: "font-mono bg-blue-50/30" },
    //   { value: "0.00001016", readOnly: true, className: "font-medium" },
    //   { value: "0.147700", readOnly: true, className: "font-medium" },
    //   { value: "0.00001659", readOnly: true, className: "font-mono" },
    //   { value: "78.90", readOnly: true, className: "text-blue-600 font-bold" },
    //   { value: "80.54", readOnly: true, className: "font-mono bg-blue-50/30 font-bold" }
    // ]
  ];

  const [data, setData] = useState(staticData);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);

  const benchmarkYear = useSelector((state) => state.benchmarkYear.year);

  useEffect(() => {
    const fetchData = async () => {
      if (!currentVessel?._id) {
        setData(staticData);
        setResponseData(null);
        return;
      }

      setLoading(true);
      try {
        const response = await getUKMRVData(currentVessel._id, benchmarkYear);
        setResponseData(response);

        if (response?.success && response?.data && Array.isArray(response.data) && response.data.length > 0) {
          setData(response.data);
        } else {
          console.warn("No valid UK MRV data found, using static data");
          setData(staticData);
        }
      } catch (err) {
        console.error("Failed to fetch UK MRV data:", err);
        setData(staticData);
        setResponseData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentVessel, benchmarkYear]);

  const showExportButton = responseData?.summary?.segmentCount > 0;

  return (
    <div className="font-sans text-sm min-h-screen bg-gray-50">
      <div className="flex items-center justify-between p-4 border-b border-gray-300">
        <VesselHeader pageTitle="UK MRV Compliance Data" />
        <div className="flex space-x-2">
          <BenchmarkYearPicker />
          {showExportButton && <ExportToExcel />}
        </div>
      </div>

      <div className="p-4">
        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-x-auto flex items-center justify-center">
          {loading ? (
            <div className="text-gray-500 text-base animate-pulse">
              Loading data...
            </div>
          ) : (
            <div className="min-w-[1100px]">
              <Spreadsheet
                data={data}
                onChange={setData}
                hideRowIndicators={true}
                hideColumnIndicators={true}
                className="enhanced-spreadsheet"
              />
            </div>
          )}
        </div>
      </div>

      {/* ---- Styling for Spreadsheet ---- */}
      <style jsx global>{`
        .enhanced-spreadsheet {
          --selected-cell: #e3f2fd;
          --selected-row: #f5f5f5;
          --selected-column: #f5f5f5;
        }
        .enhanced-spreadsheet table {
          border-collapse: separate;
          border-spacing: 0;
          width: auto !important;
        }
        .enhanced-spreadsheet td {
          border-right: 1px solid #e5e7eb !important;
          border-bottom: 1px solid #e5e7eb !important;
          padding: 10px 14px !important;
          transition: background-color 0.2s;
          white-space: nowrap;
          color: #1f2937 !important;
        }
        .enhanced-spreadsheet td,
        .enhanced-spreadsheet th {
          white-space: nowrap !important;
        }
        .enhanced-spreadsheet td:first-child {
          border-left: 1px solid #e5e7eb !important;
        }
        .enhanced-spreadsheet tr:first-child td {
          position: sticky;
          top: 0;
          background-color: #f8fafc !important;
          z-index: 5;
        }
        .enhanced-spreadsheet tr:hover td {
          background-color: #f9fafb !important;
        }
        .enhanced-spreadsheet .active-cell {
          box-shadow: inset 0 0 0 2px #3b82f6 !important;
        }
      `}</style>
    </div>
  );
};

export default UKMRV;